import * as z from 'zod';
import * as ba from './base';
import { SCRIPT_SCHEMA } from '../scripting';
import { isComponentContext, assertVueComponent } from '../helpers';
import type { RouteLocationRaw } from 'vue-router';

export interface NavigateActionArgs {
  location:
    | string
    | {
        name?: string;
        path?: string;
        hash?: string;
        query?: Dictionary<string | (string | null)[] | null | undefined>;
        params?: Dictionary<string>;
        append?: boolean;
        replace?: boolean;
      };
}

export class NavigateAction extends ba.Action<NavigateActionArgs, any> {
  static get manifest() {
    return {
      name: 'navigate',
      schema: z.object({
        location: z.union([
          z.string(),
          z.object({
            name: z.string().optional(),
            path: z.string().optional(),
            hash: z.string().optional(),
            query: z.record(z.string(), z.any()).optional(),
            params: z.record(z.string(), z.any()).optional(),
            append: z.boolean().optional(),
            replace: z.boolean().optional(),
          }),
        ]),
      }),
    };
  }

  async handle(event: ba.ActionEvent, args: NavigateActionArgs) {
    assertVueComponent(event.component);
    event.component.$router.push(args.location as RouteLocationRaw);
  }
}
